import React, { useState, useEffect, useCallback, useRef }  from 'react';
// import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

import SkeletonLoader from "../../../../../ui/SkeletonLoader";

import { formatNumber } from "../../../../../../utils/util";

import { useSelector, useDispatch } from 'react-redux';
import { getThirdPartyVendorStats, resetThirdPartyVendorStats } from "../../../../../../store/actions/thirdPartyRiskAction";

const ThirdPartyVendors = ({customerId}) =>{

    const thirdPartyVendorStatsResponse = useSelector((state) => state.thirdPartyRisk.thirdPartyVendorStats);

    const prevCustomerIdRef = useRef(null);

    const dispatch = useDispatch();

    const [thirdPartyVendor, setThirdPartyVendor] = useState(null);
    const [isLoading, setIsLoading] = useState(false)

    const fetchThirdPartyVendor = useCallback(()=>{
        setIsLoading(true)
        dispatch(getThirdPartyVendorStats(customerId))
    },[customerId, dispatch])

    useEffect(()=>{
        if(customerId !== prevCustomerIdRef.current) {
            fetchThirdPartyVendor();
            prevCustomerIdRef.current = customerId;
        }
    },[customerId, fetchThirdPartyVendor])

    useEffect(()=>{
        if(thirdPartyVendorStatsResponse !== null){            
            setThirdPartyVendor(thirdPartyVendorStatsResponse)
            dispatch(resetThirdPartyVendorStats())
            setIsLoading(false)
        }
    },[thirdPartyVendorStatsResponse, dispatch])


    return (
        <div className="bg-white-with-shadow p-4 h-100">
            {
                isLoading ?
                    <SkeletonLoader type={"line"} count={7} currentPage={"dashboardOverview"}/>
                :
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <div className="header-content d-flex justify-content-between dashboard-box-container">
                        <p className="heading">Third-Party Vendors</p>
                        {/* <p className="view-all"><img src={move} alt="search" className="position-absolute search-icon" /></p> */}
                    </div>
                    <div className="total-dashboard-scans d-flex mt-3 rounded">
                        <div className="total-dashboard-container rounded p-3">
                            <div className='d-flex'>
                                <h4 className="m-0 mt-1">{formatNumber(thirdPartyVendor?.stats?.organizations?.total)}</h4>
                                <div className="user-count mx-3 mt-2">
                                    <span className='critical-icon d-inline-block'></span>
                                    <span className='high-icon d-inline-block'></span>
                                    <span className='medium-icon d-inline-block'></span>
                                    <span className='low-icon d-inline-block'></span>
                                    <p className='total-scans-text'>Total Third-Party Vendors</p>
                                </div>
                            </div>
                            <div className="p-wrapper justify-content-between gap-3 mt-3">
                                <p className='mt-2'><span className='count-critical d-inline-block'>{formatNumber(thirdPartyVendor?.stats?.organizations?.critical)}</span>Critical</p>
                                <p className='mt-2'><span className='count-high d-inline-block mt-2'>{formatNumber(thirdPartyVendor?.stats?.organizations?.high)}</span>High</p>
                                <p className='mt-2'><span className='count-medium d-inline-block mt-2'>{formatNumber(thirdPartyVendor?.stats?.organizations?.medium)}</span>Medium</p>
                                <p className='mt-2'><span className='count-low d-inline-block mt-2'>{formatNumber(thirdPartyVendor?.stats?.organizations?.low)}</span>Low</p>
                            </div>
                        </div>
                    </div>
                </motion.div>
            }            
        </div>
    )
}

export default ThirdPartyVendors;